<template>
  <Layout v-if="aupair">
    <ChiWarning
      type="info"
      title="Important"
      text="All
          interview requests will be analyzed by CHI before approval.<br />
          You will be contacted by a customer care specialist soon thereafter, either by email or phone.<br />
          Please review this Au Pair's information below and confirm your interview request at the bottom of the page."
    />

    <ChiCard
      title="Interview Request Confirmation"
      className="text-center p-12"
    >
      <div class="-mx-12 px-12 flex flex-col items-center justify-center">
        <AuPairName :name="aupair.firstName" class="mb-5" />
        <Photo
          :src="aupair.profilePhoto"
          :alt="aupair.firstName"
          class="mb-5"
        />
        <ChildCareHours :aupair="aupair" class="mb-5" />
        <div class="w-full border-b border-purple-ap-t03 pb-5 mb-5">
          <Nationality :birthCountry="aupair.birthCountry" />
          <Age :age="aupair.birthDate" />
          <InfantCareQualified
            :infantCareQualified="aupair.infantCareQualified"
          />
          <Driver :experiencedDriver="aupair.experiencedDriver" />
          <Swimmer :swimmer="aupair.swimmer" />
        </div>
      </div>
      <div
        v-if="!processing"
        class="w-full flex flex-col lg:flex-row p-5 justify-around items-center"
      >
        <button
          @click.prevent="confirmInterviewRequest(aupair.auPairPromoProfileId)"
          class="btn bg-green-600 text-white mb-10 lg:mb-0"
        >
          Confirm interview request
        </button>
        <button @click.prevent="giveUp()" class="btn">
          Cancel
        </button>
      </div>
      <ComponentLoading v-else />
    </ChiCard>
  </Layout>
</template>

<script>
import { api } from "@/services.js";
import Layout from "@/Layout/Authenticated/Layout.vue";
import ChiWarning from "@/components/UI/ChiWarning.vue";
import ChiCard from "@/components/UI/ChiCard.vue";
import AuPairName from "@/components/AuPairs/AuPairCardItems/AuPairName.vue";
import ChildCareHours from "@/components/AuPairs/AuPairCardItems/ChildCareHours.vue";
import Nationality from "@/components/AuPairs/AuPairCardItems/Nationality.vue";
import Age from "@/components/AuPairs/AuPairCardItems/Age.vue";
import InfantCareQualified from "@/components/AuPairs/AuPairCardItems/InfantCareQualified.vue";
import Driver from "@/components/AuPairs/AuPairCardItems/Driver.vue";
import Swimmer from "@/components/AuPairs/AuPairCardItems/Swimmer.vue";
import Photo from "@/components/AuPairs/AuPairCardItems/Photo.vue";

export default {
  name: "InterviewConfirmation",
  components: {
    ChiWarning,
    ChiCard,
    Layout,
    AuPairName,
    ChildCareHours,
    Nationality,
    Age,
    InfantCareQualified,
    Driver,
    Swimmer,
    Photo,
  },
  props: ["aupair"],
  data() {
    return {
      processing: false,
    };
  },

  created() {
    if (!this.aupair) {
      this.$router.push({ name: "FavoriteAuPairs" });
    }
  },
  methods: {
    giveUp() {
      this.$router.push({ name: "FavoriteAuPairs" });
    },
    confirmInterviewRequest(id) {
      this.processing = true;
      api
        .post("/promotional/AuPairPromoProfiles/interviews", {
          auPairPromoProfileId: id,
        })
        .then(() => {
          this.$store.dispatch("getUser");
          this.processing = false;
          this.$toasted.global.notificate({
            message: "Your request for an interview was sent.",
            type: "success",
          });
          this.$router.push({ name: "FavoriteAuPairs" });
        })
        .catch((error) => {
          this.processing = false;
          this.$toasted.global.notificate({
            message: error.response.data.message,
            type: "error",
          });
        });
    },
  },
};
</script>
